export default "/assets/images/tech_page_04_sm.48cd3a18eb589a96.mp4";